<template>
    <div class="y-lesson__heading">
        <div class="y-lesson__heading">{{ $t('Access to the lesson will be closed through:') }}</div>
        <div class="countdown-container">
            <div class="flex flex-col">
                <span id="days" class="countdown-value">{{ days }}</span>
                <span class="countdown-heading">{{ $t('Days') }}</span>
            </div>
            <div class="flex flex-col">
                <span id="hours" class="countdown-value">{{ hours }}</span>
                <span class="countdown-heading">{{ $t('Hours') }}</span>
            </div>
            <div class="flex flex-col">
                <span id="minutes" class="countdown-value">{{ minutes }}</span>
                <span class="countdown-heading">{{ $t('Minutes') }}</span>
            </div>
            <div class="flex flex-col">
                <span id="seconds" class="countdown-value">{{ seconds }}</span>
                <span class="countdown-heading">{{ $t('Seconds') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DeadlineTimer",
    props: ['deadline_data', 'timezone_data'],
    data() {
        return {
            deadline: null,
            timezone: '',
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            delay: 1000,
            timerId: null,
        }
    },
    mounted() {
        this.deadline = Date.parse(this.deadline_data);
        this.timezone = this.timezone_data || 'Europe/Kiev';

        if (this.deadline > 0) {
            this.timerId = setTimeout(this.timer, this.delay);
        }
    },
    methods: {
        timer() {
            let r = 0;
            let now = this.changeTimeZone(new Date(), this.timezone);
            let diff = Math.floor((this.deadline - now) / 1000);
            let _calc = (diff, delta) => {
                r = diff % delta;
                return ~~(diff / delta);
            };

            if (diff > 0) {
                this.days = _calc(diff, 86400);
                this.hours = String(_calc(r, 3600)).padStart(2, '0');
                this.minutes = String(_calc(r, 60)).padStart(2, '0');
                this.seconds = String(r).padStart(2, '0');

                this.timerId = setTimeout(this.timer, this.delay);
            } else {
                document.location.reload();
            }
        },

        changeTimeZone(date, timeZone) {
            if (typeof date === 'string') {
                return new Date(
                    new Date(date).toLocaleString('en-US', {timeZone: timeZone})
                );
            } else if (typeof date === 'object') {
                return new Date(
                    date.toLocaleString('en-US', {timeZone: timeZone})
                );
            } else {
                throw 'Wrong type';
            }
        },
    },
}
</script>

<style scoped>
.countdown-container {
    --tw-numeric-spacing: tabular-nums;
    align-items: center;
    display: grid;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
    gap: 0.5rem;
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    /*justify-content: center;*/
    /*margin-bottom: 1.5rem;*/
    margin-top: 1rem;
    text-align: center
}

.countdown-value {
    font-family: ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;
    font-size: 1.5rem;
    line-height: 2.25rem
}

.countdown-heading {
    font-size: 1rem;
    line-height: 1.75rem
}

.flex {
    display: flex
}
.flex-col {
    flex-direction: column
}
</style>
